"use client";

import React from "react";
import { useAppStore } from "@/store/useAppStore";

export const AuthMobileButton = () => {
  const { setIsModalOpen, setActiveModal } = useAppStore();

  const showAuthModal = () => {
    setIsModalOpen(true);
    setActiveModal("auth");
  };

  return (
    <button
      onClick={showAuthModal}
      className="bg-[#CCFF00] hover:opacity-85 text-black h-11 px-8 rounded-full font-medium text-base transition-opacity cursor-pointer w-full max-w-[240px]"
    >
      Sign In
    </button>
  );
};
